module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.yesinspired.ca"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"YESInspired Events","short_name":"YES","start_url":"/","background_color":"#A0522D","theme_color":"#A0522D","display":"minimal-ui","icon":"src/images/favicon/favicon-96x96.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3dc5a526070434a0e440f24c67968125"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
